export const notifyBackendLogout = () => {
  if (typeof fetch !== "undefined") {
    fetch("/v1/auth/logout", {
      method: "POST",
      keepalive: true,
    }).catch(() => {});
    return;
  }

  if (typeof navigator !== "undefined" && navigator.sendBeacon) {
    navigator.sendBeacon("/v1/auth/logout");
  }
};

export const clearStoredAuthSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("tokenExpiration");
  localStorage.removeItem("userId");
  localStorage.removeItem("loginMethod");
  localStorage.removeItem("samlLoginUrl");
};

export const clearBrowserAuthSession = () => {
  clearStoredAuthSession();
  notifyBackendLogout();
};

export const redirectToLogin = () => {
  window.location.replace("/login");
};
